import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlMorfologico/editarControlMorfologico`, method: 'POST', body: values, token: token})
}
